module.exports = __webpack_public_path__ + "img/teacher.699991f4.png";